import React from 'react'
import { StickyHeaderOnTopScroll } from '@mobi/component-library/Misc/StickyHeaderOnTopScroll'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { TabButton, Tabs } from '@mobi/component-library/Navigation/Tabs'
import { useSearchParamState } from '@mobi/utils/hooks/useSearchParamState'
import { useDisableAppHeaderSticky } from '@core/Areas/AppHeader/hooks/useDisableAppHeaderSticky'
import type { BetLoopProfile, FollowListTabNav } from '@core/Areas/BetLoop/types'
import { MainContainer } from '@core/Components/Containers'
import { FollowList } from './Components/FollowList'

export const ProfileFollowList: React.FC<{ profile: BetLoopProfile }> = ({ profile }) => {
  const [currentTab, setCurrentTab] = useSearchParamState<FollowListTabNav>({
    values: ['followers', 'following'],
    defaultValue: 'followers',
    key: 'tab',
  })

  useDisableAppHeaderSticky()

  const handleTabClick = (tabContent: FollowListTabNav) => {
    setCurrentTab(tabContent, { shouldReplace: true })
  }

  return (
    <MainContainer background='surface300'>
      <PageHeader title={profile.displayName} />

      <StickyHeaderOnTopScroll>
        <Tabs bottomBorder='hard'>
          <TabButton
            content='Followers'
            isSelected={currentTab === 'followers'}
            onClick={() => handleTabClick('followers')}
          />
          <TabButton
            content='Following'
            isSelected={currentTab === 'following'}
            onClick={() => handleTabClick('following')}
          />
        </Tabs>
      </StickyHeaderOnTopScroll>

      <FollowList key={currentTab} currentList={currentTab} profileId={profile.id} />
    </MainContainer>
  )
}
